import { action, makeObservable, observable } from 'mobx';

class GambleStore {
  gambleCount = 0;

  totalOdd = null;

  isGamble = false;

  gambleTotalWinAmount = null;

  gambleFinished = null;

  isWin = false;

  isGamblePopupVisible = false;

  isCollectBeforeSpin = false;

  constructor() {
    makeObservable(this, {
      isGamblePopupVisible: observable,
      isWin: observable,
      totalOdd: observable,
      isGamble: observable,
      gambleCount: observable,
      gambleFinished: observable,
      gambleTotalWinAmount: observable,
      isCollectBeforeSpin: observable,
      setIsWin: action.bound,
      setIsGamble: action.bound,
      setTotalOdd: action.bound,
      setGambleCount: action.bound,
      setGambleFinished: action.bound,
      setGambleTotalWinAmount: action.bound,
      setIsGamblePopupVisible: action.bound,
      setIsCollectBeforeSpin: action.bound,
    });
  }

  setIsCollectBeforeSpin(bool) {
    this.isCollectBeforeSpin = bool;
  }

  setIsGamblePopupVisible(boolValue) {
    this.isGamblePopupVisible = boolValue;
  }

  setIsWin(boolValue) {
    this.isWin = boolValue;
  }

  setTotalOdd(oddValue) {
    this.totalOdd = oddValue;
  }

  setIsGamble(boolValue) {
    this.isGamble = boolValue;
  }

  setGambleCount(count) {
    this.gambleCount = count;
  }

  setGambleTotalWinAmount(amount) {
    this.gambleTotalWinAmount = amount;
  }

  setGambleFinished(boolValue) {
    this.gambleFinished = boolValue;
  }
  resetStore() {
    this.gambleCount = 0;

    this.totalOdd = null;

    this.isGamble = false;

    this.gambleTotalWinAmount = null;

    this.gambleFinished = null;

    this.isWin = false;

    this.isGamblePopupVisible = false;

    this.isCollectBeforeSpin = false;
  }
}

export const gambleStore = new GambleStore();
